import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => <FormattedMessage id="login.new-to-idagio" defaultMessage="New to IDAGIO?" />;
